import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_USER(state, users) {
    state.cached = users
  },
}

export const actions = {

  init({ state, dispatch }) { },


  fetchUsers(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/base/users/${query}`).then((response) => {
      const users = response.data
      context.commit('CACHE_USER', users)
      return users
    })
  },

  fetchUsersForOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/base/users/for_options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchUsersOptions(context, query) {
    query = query || ''
    return axios.options(`${serverUrl}/base/users/?page_size=500&${query}`).then((response) => {
      return response.data
    })
  },

  fetchCoordinatorsOptions(context, query) {
    query = query || ''
    return axios.options(`${serverUrl}/base/users/coordinadores/?page_size=500&${query}`).then((response) => {
      return response.data
    })
  },

  fetchCoordinators(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/base/users/coordinadores/?page_size=500&${query}`).then((response) => {
      return response.data
    })
  },



  fetchUsersDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  fetchUserInfo(context, id) {
    return axios.get(`${serverUrl}/base/users-info/${id}/stake_holders_info`).then((response) => {
      return response.data
    })
  },


  createUpdateUsers(context, formData) {
    let promise = null
    let groups = []
    if (formData.groupsTemp) {
      groups = [...formData.groupsTemp]
    }

    if (formData.url) {
      promise = axios.put(formData.url, formData)

    } else {
      promise = axios.post(`${serverUrl}/base/users/`, formData)

    }
    return promise.then(
      async (response) => {
        if (groups.length > 0) {
          let data = {
            groups,
            username: response.data.username,
            email: response.data.email,
            app_sections_users: response.data.app_sections_users
          }
          let promise = axios.put(response.data.url, data)
          promise.then(async (response) => {
            return response.data
          })
        }
        return response.data
      }
    )
  },

  deleteUsers(context, url) {
    let promise = null
    promise = axios.delete(url)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  changePassword(context, formData) {
    let promise = null
    promise = axios.put(`${formData.url}set_password/`, formData)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  updatePhotos(context, formData) {
    let promise = null
    promise = axios.put(`${formData.get('url')}set_photo/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  // This request is auto-authenticated by app user
  checkIfUserExists(context, username) {
    return axios.get(`${serverUrl}/base/users/exists/?search=${username}`, { 'appRequest': true }).then((response) => {
      return response.data
    })
  },

  registerUsers(context, formData) {
    // Used for user registration forms
    let promise = null
    if (formData.url) {
      promise = axios.put(formData.url, formData)
    } else {
      promise = axios.post(`${serverUrl}/base/users/register/`, formData, { 'appRequest': true })
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  registerRedUsers(context, payload) {
    // Used for user registration red
    return axios.post(`${serverUrl}/base/users/register_red/`, payload)
      .then((response) => {
        return response.data
      })
  },

  addStakeHolderToUser(context, payload) {
    return axios.put(`${serverUrl}/base/users-info/${payload.userId}/add_stake_holders/`, payload)
      .then((response) => {
        return response.data
      })
  },

  removeStakeHolderToUser(context, payload) {
    return axios.put(`${serverUrl}/base/users-info/${payload.userId}/delete_stake_holders/`, payload)
      .then((response) => {
        return response.data
      })
  },

  changeFirstLoginRed(context, userId) {
    return axios.put(`${serverUrl}/base/users-info/${userId}/first_login/`)
      .then((response) => {
        return response.data
      })
  },

  changeFirstLoginAction({ roomState }, { url, isFirstLogin }) {
    // const url = roomState.auth.currentSession.user.url
    return axios
      .put(`${url}first-login/`, { is_first_login: isFirstLogin })
      .then((response) => {
        return response.data
      }
      )
  }

}